import { createFileRoute } from '@tanstack/react-router';
import Fees from '../../../features/baseData/fees/fees';
import {
  createPermissionGuard,
  FEES_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gebuehren/')({
  component: Fees,
  beforeLoad: createPermissionGuard(getPermissionSet(FEES_PERMISSIONS, 'READ')),
});

export const ListFeesRoute = Route;
